export default __webpack_public_path__ + "9f6bf6d1b4c146cdd71acb8135320cd0.png";